import React, { useEffect, useState } from "react";
import { Modal, View, Text, TextInput, Pressable, StyleSheet } from "react-native";

type Props = {
  visible: boolean;
  title: string;
  description?: string;
  initialValue?: string;
  confirmText?: string;
  onCancel: () => void;
  onConfirm: (value: string) => void;
};

export default function NamePromptModal({
  visible,
  title,
  description,
  initialValue,
  confirmText,
  onCancel,
  onConfirm,
}: Props) {
  const [value, setValue] = useState(initialValue ?? "");

  useEffect(() => {
    if (visible) setValue(initialValue ?? "");
  }, [visible, initialValue]);

  const trimmed = value.trim();
  const canSave = trimmed.length >= 2;

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onCancel}>
      <View style={styles.backdrop}>
        <View style={styles.card}>
          <Text style={styles.title}>{title}</Text>
          {description ? <Text style={styles.desc}>{description}</Text> : null}

          <TextInput
            value={value}
            onChangeText={setValue}
            placeholder="Type name…"
            autoCapitalize="words"
            style={styles.input}
          />

          <View style={styles.row}>
            <Pressable onPress={onCancel} style={[styles.btn, styles.btnGhost]}>
              <Text style={styles.btnText}>Cancel</Text>
            </Pressable>

            <Pressable
              onPress={() => onConfirm(trimmed)}
              style={[styles.btn, !canSave && styles.btnDisabled]}
              disabled={!canSave}
            >
              <Text style={styles.btnText}>{confirmText ?? "Save"}</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.45)",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
  },
  card: {
    width: "100%",
    maxWidth: 520,
    backgroundColor: "white",
    borderRadius: 16,
    padding: 14,
  },
  title: { fontSize: 16, fontWeight: "800" },
  desc: { marginTop: 6, opacity: 0.7 },
  input: {
    marginTop: 12,
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 12,
    paddingHorizontal: 12,
    paddingVertical: 10,
  },
  row: { flexDirection: "row", justifyContent: "flex-end", gap: 10, marginTop: 12 },
  btn: {
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 12,
    paddingVertical: 10,
    paddingHorizontal: 14,
  },
  btnGhost: { backgroundColor: "#fafafa" },
  btnDisabled: { opacity: 0.5 },
  btnText: { fontWeight: "800" },
});
